var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Row } from 'antd';
import { CardImage } from '../../../../../../components/cards/CardImage';
import { CardTextBlock } from '../../../../../../components/cards/CardTextBlock';
var PreviewCards = function () {
    return (_jsxs("div", { children: [_jsx(Row, { children: ['Qc', 'Qd', 'Qh', 'Qs', '-'].map(function (item, index) { return (_jsx(CardImage, { card: item, isSmall: true }, index)); }) }), _jsx(Row, __assign({ style: { height: '25px', marginTop: 8, marginLeft: 3 } }, { children: _jsx(CardTextBlock, { cards: 'QcQdQhQs', isSquare: true, isFullWidth: true, style: { width: '120px' } }) }))] }));
};
export default PreviewCards;
